import React, { useEffect, useState } from 'react';
import Styles from "./styles.module.scss"
import Headline6 from "../../components/headings/Headline6";
import FormHead from "../../components/headings/FromHead";
import { Icon } from '@iconify/react';
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import Button from "../../components/button";
import DeductionFormField from './additionalInputForm';
import { postAPI } from '../../api/api';
import { REACT_APP_CANDIDATE_FRELLANCER } from '../../utils/common';
import AdditionalInputFormField from './additionalInputForm';
import classnames from "classnames";
import { DropDownInput } from "../../wrappers/selectInput";
import { FormInput } from "../../wrappers/formInput";
import { TaxForm } from './taxForm';
import { GstForm } from './gstForm';

const { v4: uuidv4 } = require("uuid");

interface Props {
  timesheetId?: any,
  projectId?: any,
  candidateData?: any
  paymentDetails?: any
  DeductionDetails?: any
  arrearsDetails?: any
  timesheetDetails?: any
  submitPayment?: any
  deductions?: any
  disable?: any
}

export type paymentDetailsForm = {
  reason: string,
  amount: number,
  percentage: number,
  type: string,
  DeductionDetails: string,
  arrearsDetails: any,
  billingType: string,
  currencyType: string,
};

const validationSchema = Yup.object({
  // email: Yup.string().required("Field is required").email('Please provide a valid Work Email'),
  // companyName: Yup.object().required("Field is required").nullable(),
  // designation: Yup.string().required("Field is required"),
});

const PaymentTab: React.FC<Props> = ({ paymentDetails, timesheetDetails, submitPayment, DeductionDetails, arrearsDetails, disable }) => {

  const { register, control, handleSubmit, reset, watch, setValue } = useForm({
    defaultValues: {
      deductionField: DeductionDetails,
      arrearsField: arrearsDetails
    }
  });

  const [sheetDetails, setSheetDetails] = useState<any>()
  const [projectDetails, setProjectDetails] = useState<any>()
  const [additionalInput, setAdditionalInput] = useState<any>([]);
  const [taxDeduction, setTaxDeduction] = useState<any>([]);
  const [showValidationMessage, setShowValidationMessage] = useState<any>(false);
  const [arrearsValidationMessage, setArrearsValidationMessage] = useState<any>(false);
  const [disabled, setDisabled] = useState<any>(false);
  const [noerror, setNoerror] = useState<any>(true);
  const [overalltotal, setOverallTotal] = useState<any>(timesheetDetails[0] && timesheetDetails[0].candidate_adjusted_overall_payment);
  const [subTotal, setSubTotal] = useState<any>(timesheetDetails[0] && timesheetDetails[0].candidate_overall_payment && timesheetDetails[0].candidate_overall_payment ? timesheetDetails[0].candidate_overall_payment : 0)
  const { fields: fieldsList1, remove: removeList1,  append: appendList1 } = useFieldArray({ 
    control, 
    name: "deductionField" 
  })

  const { fields: fieldsList2, remove: removeList2, append: appendList2 } = useFieldArray({ 
    control, 
    name: "arrearsField" 
  })
  const [tdsPercent, setTDSpercent] = useState<number>(timesheetDetails[0] && timesheetDetails[0].tds_percentage_candidate !== null ? timesheetDetails[0] && timesheetDetails[0].tds_percentage_candidate : 0)
  const [tdsValue, setTdsValue] = useState<number>(timesheetDetails[0] && timesheetDetails[0].tds_amount_candidate !== null ? timesheetDetails[0] && timesheetDetails[0].tds_amount_candidate : 0)
  const [gstPercent, setGstPercent] = useState<number>(timesheetDetails[0] && timesheetDetails[0].gst_percentage_candidate !== null ? timesheetDetails[0] && timesheetDetails[0].gst_percentage_candidate : 0)
  const [gstAmount, setGstAmount] = useState<number>(timesheetDetails[0] && timesheetDetails[0].gst_amount_candidate !== null ? timesheetDetails[0] && timesheetDetails[0].gst_amount_candidate : 0)
  
  const onSubmit = (data: any) => {
    
    setShowValidationMessage(true);
    setArrearsValidationMessage(true)
    if (noerror) {      
      let overAllPay = timesheetDetails[0].candidate_overall_payment ? timesheetDetails[0].candidate_overall_payment : 0;
      let adjustedPay = timesheetDetails[0].candidate_adjusted_overall_payment ? timesheetDetails[0].candidate_adjusted_overall_payment : 0;

      const data1 = additionalInput.filter((value: any) => value.type === 'Deduction');
      const data2 = additionalInput.filter((value: any) => value.type === 'Addition');

      const deductionsdata1 = data1.map((item: any) => {
        overAllPay = overAllPay - parseInt(item.amount);
        delete item.id;
        delete item.type
        return item;
      })
   
      const arrearsdata = data2.map((item: any) => {
        overAllPay = overAllPay + parseInt(item.amount)
        item.arrearsId = item.deductionId;
        delete item.deductionId
        delete item.id;
        delete item.type
        return item;
      })

      let deductionSum = deductionsdata1 && deductionsdata1.reduce(function (sum: any, current: any) {
        return sum + current.amount;
      }, 0)
      let arrearsum = arrearsdata && arrearsdata.reduce(function (sum: any, current: any) {
        return sum + current.amount;
      }, 0)

      const deductionsdata = [...deductionsdata1]
 
        let payload = {
          "timesheetId": timesheetDetails[0].timesheet_id,
          "overAllAmount": subTotal && parseFloat(subTotal.toFixed(1)),
          "deductions": deductionsdata,
          "arrears": arrearsdata,
          "doneFor": "Candidate",
          "adjustedOverallPay": overalltotal && parseFloat(overalltotal.toFixed(1)),
          "tdsPercentage": tdsPercent,
          "tdsAmount": tdsValue,
          "gstPercentage": gstPercent,
          "gstAmount": gstAmount,
          "totalDeductions": deductionSum,
          "totalArrears": arrearsum
        }   
      setDisabled(true); 
        submitPayment(payload)      
        setShowValidationMessage(false);
    }
  }
  
  const onClick = (e: any) => {
    e.preventDefault()
    appendList1({
      reason: '',
      amount: '',
      type: '',
    })
  }
  
  const arrearsOnClick = (e: any) => {
    e.preventDefault()
    appendList2({
      reason: '',
      percentage: '',
      type: '',
    })
  }
  
  const setAdditionalInputChange = (data: any) => {
    checkCalculation(data, tdsPercent, gstPercent)
    setAdditionalInput(data);
  }

  const changeDisabled = () => {
    setDisabled(false);
  }

  const checkCalculation = (data: any, tdsPercent: number, gstPercent:  number) => {
    
    let overAllPay = timesheetDetails[0] && timesheetDetails[0].candidate_overall_payment && timesheetDetails[0].candidate_overall_payment ? timesheetDetails[0].candidate_overall_payment : 0;
    let tdsReducedSubTotal = 0
    let gstAddedSubTotal = 0
    const deductionsdata = data.map(function (item: any) {   
        if (item.type == 'Deduction' && parseInt(item.amount) > 0) {          
          overAllPay = overAllPay - parseInt(item.amount);
        } else if (item.type == 'Addition' && parseInt(item.amount) > 0) {
          overAllPay = overAllPay +  parseInt(item.amount);
        }
    })
    setSubTotal(overAllPay)

    if(tdsPercent === 0 || tdsPercent === null){
      tdsReducedSubTotal = 0 
    }else{
      tdsReducedSubTotal = overAllPay * tdsPercent / 100
    }
    if(gstPercent === 0 || gstPercent === null){
      gstAddedSubTotal = 0 
    }else{
      gstAddedSubTotal = overAllPay * gstPercent / 100
    }
    let finalValue = overAllPay + gstAddedSubTotal - tdsReducedSubTotal
    setOverallTotal(finalValue)

  }

    const downloadHandle = (fileName: string,) => {
      
        let value = {
          "action": "getObject",
          "filename": fileName,
          "bucketName": timesheetDetails[0] && timesheetDetails[0].invoice_signed === true ? "ellow-prod-doc-upload/signedInvoices" : "ellow-prod-doc-upload",
        } 
        postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {
          let signedUrl = data.url
          fetch(signedUrl).then((response: any) => {
            response.blob().then((blob: any) => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement('a');
              alink.href = fileURL;
              alink.download = fileName;
              alink.click();
            })
          })
        });
       }

       const onsubmitTaxForn= (data: any) => {
        if(!Number.isNaN(data.percentage)){
          setTDSpercent(data.percentage)
          let amount: number = subTotal * parseInt(data.percentage) / 100
          setTdsValue(amount)
          checkCalculation(additionalInput, data.percentage, gstPercent)
        }else{
          setTDSpercent(0)
          setTdsValue(0)
          checkCalculation(additionalInput, 0, gstPercent)
        }
       }

      const onsubmitGstForm = (data: any) => {
        if(!Number.isNaN(data.percentage)){
          setGstPercent(data.percentage)
          let amount: number = subTotal * parseInt(data.percentage) / 100
          setGstAmount(amount)
          checkCalculation(additionalInput, tdsPercent, data.percentage)
        }else{
          setGstAmount(0)
          setGstPercent(0)
          checkCalculation(additionalInput, tdsPercent, 0)
        }
      }       

  return (
    <section >
      <div className="contentBox mb-40">
        <div className="innerPadd48">
          <div className={Styles.basicDetails}>
          <div className={Styles.basicHeadWrap}>
            <Headline6>Basic Info</Headline6>
            {timesheetDetails[0] && timesheetDetails[0].invoice_file_name && <div onClick={() => downloadHandle(timesheetDetails[0].invoice_file_name)} className="link-btn-green">View invoice</div>}
          </div>
            <div className={Styles.basicInfoCard}>
              <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                  <label>Resources Cost:</label>
                  {paymentDetails && paymentDetails[0] && `${paymentDetails[0].candidateRate} ${paymentDetails[0].candidateCurrencyType} / ${paymentDetails[0].candidateBillingType}`}
                </div>
                <div className={Styles.form}>
                  <label>No of holidays:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].holidays}
                </div>
              </div>
              <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                  <label>No of total working days:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].total_working_days}
                </div>
                <div className={Styles.form}>
                  <label>No of paid leaves per month:</label>
                  1
                </div>
              </div>
              <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                  <label>Estimated pay:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].estimate_payment && `${timesheetDetails[0].estimate_payment.toFixed(1)} INR / Monthly`}
                </div>
                <div className={Styles.form}>
                  <label>Leaves taken this month:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].leaves}
                </div>
              </div>
              <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                  <label>No of actual working days:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].actual_working_days}
                </div>
                <div className={Styles.form}>
                  <label>No of compension off:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].comp_off}
                </div>
              </div>
              <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                  <label>No of carry forward leaves available this month:</label>
                  {timesheetDetails && timesheetDetails[0] && timesheetDetails[0].carry_forward ? timesheetDetails[0].nextCarryForward : '0'}
                </div>
                <div className={Styles.form}>
                  <label>Overtime: </label>
                    {timesheetDetails[0] && timesheetDetails[0].overtime === null ? '0' : timesheetDetails[0] && timesheetDetails[0].overtime}
                </div>
              </div>
            </div>
          </div>
          <form>
          <div className={Styles.deductionsWrap}>
            <div className={Styles.paymentCard}>
              <div className={Styles.paymenthead}>Calculated Pay: <span>₹{timesheetDetails && timesheetDetails[0] && timesheetDetails[0].candidate_actual_payment && timesheetDetails[0].candidate_actual_payment.toFixed(1)}</span></div>
              {/* <FormHead>Additional Deductions</FormHead> */}
              <div className={Styles.deductionsBtn}>
                <button onClick={(e: any) => onClick(e)} className={Styles.addButton}><Icon icon="ph:plus-circle" /></button>Additional Input
              </div>
              {fieldsList1.map((item, index) => {
                return (
                  <>
                    <AdditionalInputFormField setAdditionInputChange={setAdditionalInputChange} showValidationMessage={showValidationMessage} control={control} remove={removeList1} keyId={uuidv4()} additionalInput={additionalInput} setNoerror={setNoerror}
                      key={item.id}
                      removeID={index}
                      CurrencyType={paymentDetails && paymentDetails[0] && paymentDetails[0].ellowCurrencyType}
                      billingType={paymentDetails && paymentDetails[0] && paymentDetails[0].ellowBillingType}
                      defaultValues={item}
                      changeDisabled={changeDisabled}
                      disabled={disabled}
                    />
                  </>
                )
              })}
                <div className={Styles.actionWrap}>
                <div className={Styles.paymenthead}>Sub Total: <span>₹{subTotal && subTotal.toFixed(1)}</span></div>
              </div>
              <div className={Styles.deductionsBtn}>
                Tax Deductions
              </div>
              <div className={Styles.taxWrap}>
                <TaxForm ClickHandler={onsubmitTaxForn} percentage={timesheetDetails[0]  && timesheetDetails[0].tds_percentage_candidate}/>
              </div>
              <div className={Styles.deductionsBtn}>
                Gst
              </div>
              <div className={Styles.taxWrap}>
                <GstForm ClickHandler={onsubmitGstForm} percentage={timesheetDetails[0]  && timesheetDetails[0].gst_percentage_candidate}/>
              </div>
              <div className={Styles.actionWrap}>
                <div className={Styles.paymenthead}>Net bill: <span>₹{overalltotal && overalltotal.toFixed(1)}</span></div>
              </div>
              <div className={Styles.totalaction}>
                <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" disabled={disable}>Save</Button>
              </div>
            </div>
          </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default PaymentTab;

